import React from 'react'
import store from "store";
import { Button } from '@material-ui/core'
import { useStyles } from '../../Attendance/styles'

const TestTypeButtons = ({ onSelectTestType, testTypes, selectedTestType }) => {
  /* ---THIS IS FOR BHASYAM--- */
  const instituteId = store.get("user").institute;
  const classes = useStyles()
  return (
    <div className={classes.testTypeButtons}>
      {testTypes.map((type, index) => (
        <Button
          key={index}
          variant='contained'
          onClick={() => onSelectTestType(index)}
          color={index === selectedTestType ? 'primary' : ''}
          className={
            index === selectedTestType ? classes.activeBtn : classes.inActiveBtn
          }
        >
          {instituteId === "5e7370083d8520a40c4ceaaa" && type === "BIOP" ? "JEEMAINS ZCO" : type}
        </Button>
      ))}
    </div>
  )
}

export default TestTypeButtons
